import { createTheme } from '@mui/material';
import { ThemeProvider } from 'styled-components';
import ManageFlags from '../../components/ManageFlags/ManageFlags';
import "../../components/CommunicationTemplete/CommunicationTemplate.css";

const defaultTheme = createTheme();

const ManageFlagsPage = () => {
  return (
    <ThemeProvider theme={defaultTheme}>
      <div className="ctpl-page-header">
        <div className="ctpl-title-col">
          <h1>Manage Flags</h1>
          <p>Create and organize flags by category to tag contacts and templates.</p>
        </div>
      </div>

      <ManageFlags />
    </ThemeProvider>
  );
};

export default ManageFlagsPage;